import styled from "styled-components";
import { Icon, OverflowMenu } from "@ebscois/react-component-library";

export const StyledLi = styled.li`
  padding: ${({ theme }) => theme.space.sm};
`;

export const StyledOverflowMenu = styled(OverflowMenu)`
  padding: ${({ theme }) => theme.space.sm};
`;

export const StyledIcon = styled(Icon)`
  cursor: pointer;
`;
